<div class="search-suggester" [ngClass]="{ active: searchSuggestionsActive }">
  <form
    class="form-inline search-input-frm"
    [formGroup]="searchForm"
    #form="ngForm"
  >
    <div class="form-group search-group">
      <div class="search-input">
        <span class="search-icon">
          <fa-icon [icon]="['fas', 'arrow-right-to-bracket']"></fa-icon>
        </span>
        <!-- scanner-disable-next-line R6 -- live filter box of the header search (WAP-1568) -->
        <input
          type="text"
          #searchInput
          formControlName="query"
          [value]="searchQuery"
          (keyup)="onKeyUp(searchInput.value, $event)"
          (focus)="onFocus()"
          placeholder="{{
            'search-suggest.placeholder-suggest-feed-or-object' | translate
          }}"
        />
      </div>
    </div>
    @if (suggestionsLoading$ | async) {
      <app-loading [size]="'1x'"></app-loading>
    }
  </form>
  <div class="search-suggest">
    @if (!recentObjectsMode) {
      <div class="title">
        {{ "search-suggest.title.all-mathes" | translate }}
      </div>
    }
    @if (recentObjectsMode) {
      <div class="title">
        {{ "search-suggest.title.recents" | translate }}
      </div>
    }
    @if (
      recentObjectsMode === false &&
      (!searchSuggestions() || searchSuggestions().length == 0)
    ) {
      <div class="collections suggest-list">
        <span>{{
          "search-suggest.title.no-objects-match-the-criteria" | translate
        }}</span>
      </div>
    }
    <ul class="suggest-items">
      @if (searchSuggestions()?.length) {
        @for (suggestion of searchSuggestions(); track $index) {
          <li
            (click)="selectSuggestion(suggestion)"
            class="suggest-item"
            [ngClass]="{ active: suggestion.active }"
          >
            <div class="suggest-item-title">
              <span class="icon">
                @if (suggestion.icon) {
                  <fa-icon [icon]="suggestion.icon"></fa-icon>
                }
              </span>
              <span class="suggestion">
                <i class="fa fa-search"></i>
                <span
                  [innerHTML]="suggestion.title | highlight: typedQuery"
                ></span>
              </span>
            </div>
            @if (recentObjectsMode) {
              <div class="remove">
                <fa-icon
                  class="clear-icon"
                  [icon]="['fas', 'times']"
                  (click)="removeRecentObject($event, suggestion)"
                ></fa-icon>
              </div>
            }
          </li>
        }
      } @else {
        <li class="suggest-item no-results">
          {{ "search-suggest.message.no-suggestions-found" | translate }}
        </li>
      }
    </ul>

    <!-- Template for empty state -->
  </div>
</div>
